import { render, staticRenderFns } from "./QcOrderItemSection.vue?vue&type=template&id=2ccb9e96&scoped=true&"
import script from "./QcOrderItemSection.ts?vue&type=script&lang=js&"
export * from "./QcOrderItemSection.ts?vue&type=script&lang=js&"
import style0 from "./QcOrderItemSection.vue?vue&type=style&index=0&id=2ccb9e96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb9e96",
  null
  
)

export default component.exports